/*  
    This module is used to dynamically build the content_style property of the tinyMCE drop 
    More information on content_style: https://www.tiny.cloud/docs/tinymce/latest/add-css-options/#content_style
*/
define('drops/richTextEditor/contentStylesBuilder',[], function () {

    var contentStyles = ""

    var getContentStyles = function () {
        return contentStyles;
    };

    var containImages = function (containImagesEnabled) {
        if (containImagesEnabled) {
            contentStyles += "img { width: 100% !important; height: auto !important; } ";
        }
    };

    var removeMarginAndPadding = function (removeMarginAndPaddingEnabled) {
        if (removeMarginAndPaddingEnabled) {
            contentStyles += "p { margin: 0; padding: 0; } ";
        }
    };

    return {
        getContentStyles: getContentStyles,
        containImages: containImages,
        removeMarginAndPadding: removeMarginAndPadding,
    };
});
